import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = BACKEND_URL;

export const publicApi = axios.create({
    baseURL: BACKEND_URL,
    headers: { "Content-Type": "application/json" },
});

export const adminApi = axios.create({
    baseURL: BACKEND_URL,
    headers: { "Content-Type": "application/json" },
});

export const ACTIVE_AGENT_KEY = "orchid_active_agent";
export function getActiveAgent() {
    return localStorage.getItem(ACTIVE_AGENT_KEY) || "priya";
}
export function setActiveAgent(id) {
    localStorage.setItem(ACTIVE_AGENT_KEY, id);
}

adminApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("orchid_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    // Scope every admin data request to the currently selected agent (Priya / Tara)
    // so documents, Q&A, chats, leads and settings stay fully isolated per agent.
    config.params = { agent_id: getActiveAgent(), ...(config.params || {}) };
    return config;
});

adminApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem("orchid_admin_token");
            if (window.location.pathname !== "/login") {
                window.location.assign("/login");
            }
        }
        return Promise.reject(err);
    }
);

export const agentApi = axios.create({
    baseURL: BACKEND_URL,
    headers: { "Content-Type": "application/json" },
});

agentApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("orchid_agent_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

agentApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem("orchid_agent_token");
            if (window.location.pathname !== "/agent/login") {
                window.location.assign("/agent/login");
            }
        }
        return Promise.reject(err);
    }
);
